// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__aYa4s","blur":"Menu_blur__GBLZ0"};